<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { ref } from 'vue'
import NBToggle from '@/app/Checkout/components/common/NBToggle/index.vue'

let subscribe = ref(false)
</script>
